export default "__VITE_ASSET__CDA0AVan__"